/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

export enum CaptionInfoKey {
  CAPTION_BG_COLOR_KEY = 'CAPTION_BG_COLOR_KEY',
  CAPTION_BG_OPACITY_KEY = 'CAPTION_BG_OPACITY_KEY',
  CAPTION_EDGE_COLOR_KEY = 'CAPTION_EDGE_COLOR_KEY',
  CAPTION_EDGE_TYPE_KEY = 'CAPTION_EDGE_TYPE_KEY',
  CAPTION_FONT_COLOR_KEY = 'CAPTION_FONT_COLOR_KEY',
  CAPTION_FONT_OPACITY_KEY = 'CAPTION_FONT_OPACITY_KEY',
  CAPTION_FONT_SIZE_KEY = 'CAPTION_FONT_SIZE_KEY',
  CAPTION_FONT_STYLE_KEY = 'CAPTION_FONT_STYLE_KEY',
  CAPTION_MODE_KEY = 'CAPTION_MODE_KEY',
  CAPTION_ONOFF_KEY = 'CAPTION_ONOFF_KEY',
  CAPTION_STYLE_KEY = 'CAPTION_STYLE_KEY',
  CAPTION_WINDOW_COLOR_KEY = 'CAPTION_WINDOW_COLOR_KEY',
  CAPTION_WINDOW_OPACITY_KEY = 'CAPTION_WINDOW_OPACITY_KEY',
}

export enum CaptionColor {
  'CAPTION_COLOR_BLACK' = '0,0,0',
  'CAPTION_COLOR_BLUE' = '0,0,255',
  'CAPTION_COLOR_CYAN' = '0,255,255',
  'CAPTION_COLOR_DEFAULT' = '255,255,255',
  'CAPTION_COLOR_GREEN' = '0,255,0',
  'CAPTION_COLOR_MAGENTA' = '255,0,255',
  'CAPTION_COLOR_RED' = '255,0,0',
  'CAPTION_COLOR_WHITE' = '255,255,255',
  'CAPTION_COLOR_YELLOW' = '255,255,0',
}

export enum CaptionEdge {
  'CAPTION_EDGE_DEPRESSED' = '0.3rem 0.3rem 0 rgb(color)',
  'CAPTION_EDGE_DROP_SHADOWED' = '-0.5rem -0.5rem 0.5rem rgb(color)',
  'CAPTION_EDGE_NONE' = '0 rgb(color)',
  'CAPTION_EDGE_RAISED' = '-0.3rem -0.3rem 0 rgb(color)',
  'CAPTION_EDGE_UNIFORM' = `
    -0.3rem -0.3rem 0 rgb(color),
    0.3rem -0.3rem 0 rgb(color),
    -0.3rem 0.3rem 0 rgb(color),
    0.3rem 0.3rem 0 rgb(color)`,
}

export enum CaptionFontSize {
  'CAPTION_SIZE_DEFAULT' = '5rem',
  'CAPTION_SIZE_EXTRA_LARGE' = '7rem',
  'CAPTION_SIZE_LARGE' = '6rem',
  'CAPTION_SIZE_SMALL' = '4rem',
  'CAPTION_SIZE_STANDARD' = '5rem',
}

export enum CaptionFontStyle {
  'CAPTION_FONT_DEFAULT' = '',
  'CAPTION_FONT_STYLE0' = '',
  'CAPTION_FONT_STYLE1' = '"Cutive Mono",Consolas,Courier,monopace',
  'CAPTION_FONT_STYLE2' = '"Roboto Slab","Times New Roman",Times,serif',
  'CAPTION_FONT_STYLE3' = '"Roboto Mono",helvetica,sans-serif',
  'CAPTION_FONT_STYLE4' = '"Open Sans",Arial,sans-serif',
  'CAPTION_FONT_STYLE5' = '"Itim","comic sans",cursive,sans-serif',
  'CAPTION_FONT_STYLE6' = '"Dancing Script",cursive',
  'CAPTION_FONT_STYLE7' = '"Allegreya Sans",sans-serif',
}

const googleFontsUrl = 'https://fonts.googleapis.com/css?family=';
export enum CaptionFontUrl {
  'CAPTION_FONT_DEFAULT' = '',
  'CAPTION_FONT_STYLE0' = '',
  'CAPTION_FONT_STYLE1' = `${googleFontsUrl}Cutive+Mono`,
  'CAPTION_FONT_STYLE2' = `${googleFontsUrl}Roboto+Slab`,
  'CAPTION_FONT_STYLE3' = `${googleFontsUrl}Roboto+Mono`,
  'CAPTION_FONT_STYLE4' = `${googleFontsUrl}Open+Sans`,
  'CAPTION_FONT_STYLE5' = `${googleFontsUrl}Itim`,
  'CAPTION_FONT_STYLE6' = `${googleFontsUrl}Dancing+Script`,
  'CAPTION_FONT_STYLE7' = `${googleFontsUrl}Alegreya+Sans+SC`,
}

export enum CaptionOpacity {
  'CAPTION_OPACITY_DEFAULT' = '1',
  'CAPTION_OPACITY_FLASHING' = '1',
  'CAPTION_OPACITY_HIGHLY_TRANSLUCENT' = '0.25',
  'CAPTION_OPACITY_SLIGHTLY_TRANSLUCENT' = '0.75',
  'CAPTION_OPACITY_SOLID' = '1',
  'CAPTION_OPACITY_TRANSLUCENT' = '0.5',
  'CAPTION_OPACITY_TRANSPARENT' = '0',
}

export enum CaptionStyle {
  CAPTION_STYLE_BOLD = 'CAPTION_STYLE_BOLD',
  CAPTION_STYLE_DEFAULT = 'CAPTION_STYLE_DEFAULT',
  CAPTION_STYLE_ITALIC = 'CAPTION_STYLE_ITALIC',
}

export enum TvInfoMenuKey {
  ACCESSIBILITY_FOCUS_ZOOM = 12,
  ACCESSIBILITY_HIGH_CONTRAST = 13,
  ACCESSIBILITY_VOICE_GUIDE_SPEED = 20,
  CAPTION_BG_COLOR_KEY = 6,
  CAPTION_BG_OPACITY_KEY = 7,
  CAPTION_EDGE_COLOR_KEY = 9,
  CAPTION_EDGE_TYPE_KEY = 8,
  CAPTION_FG_COLOR_KEY = 4,
  CAPTION_FG_OPACITY_KEY = 5,
  CAPTION_FONT_SIZE_KEY = 2,
  CAPTION_FONT_STYLE_KEY = 3,
  CAPTION_MODE_KEY = 1,
  CAPTION_ONOFF_KEY = 0,
  CAPTION_STYLE_KEY = 21,
  CAPTION_WINDOW_COLOR_KEY = 10,
  CAPTION_WINDOW_OPACITY_KEY = 11,
  PRIMARY_AUDIO_LANGUAGE_KEY = 18,
  SECONDARY_AUDIO_LANGUAGE_KEY = 19,
  SMARTHUB_CHANNEL_BOUND_APPS_TICKER = 14,
  SUBTITLE_MODE_KEY = 17,
  SUBTITLE_ONOFF_KEY = 16,
  VOICE_GUIDE_KEY = 15,
}

export enum TvInfoMenuValue {
  ON = 1,
}
